import type { IUserPreference } from '@/interface/user-preference.interface'
import * as React from 'react'

interface UserPreferenceContextType {
  userPreferences: IUserPreference[] | null
  isLoading: boolean
  error: Error | null
  upsertUserPreference: (key: string, value: string, active: boolean) => Promise<void>
}

export const UserPreferenceContext = React.createContext<UserPreferenceContextType>({
  userPreferences: null,
  isLoading: false,
  error: null,
  upsertUserPreference: async () => {},
})
